<div class="content-section flex flex-column flex-grow max-width-minus-side-nav" style="--grow-value: 1">
    <div class="" *ngIf="approvalsTabToShow == 'details'"> <!-- Removed class ' main-content' since the leave master is moved to the Company settings page -->
        <div class="flex flex-direction-row">
          <div class="row flex flex-row">
            <!-- <div class="approval">Approvals</div> -->
            <div class="leaves">
              <app-drop-down [lists]='option' dropDownWidth="120px"
                  dropDownHeight="36px" dropFontWeight="500" dropFontSize="12px"
                  (dataEmit)="emittedValue($event, 'UI')"
                  dropFontColor="#434555" dropBorderRadius="5px 5px 5px 5px" [selectedData]="eventValue">
              </app-drop-down>
            </div>
          </div>
        </div>
        <div [ngSwitch]="eventValue">
            <div *ngSwitchCase="'Leaves'">
              <app-approval-notificationtab [activeDropDownComp]="activeDropDownComp"></app-approval-notificationtab>
            </div>
            <div *ngSwitchCase="'Expense'">
              <app-expense-tab [activeDropDownComp]="activeDropDownComp"></app-expense-tab>
            </div> 
            <div *ngSwitchCase="'Skill'"></div>
            <div *ngSwitchCase="'Assert'"></div>
        </div>
    </div>
    <div class="main-content" *ngIf="approvalsTabToShow == 'settings'">
        Settings
    </div>
    <!-- SKS21NOV24 dynamic table -->
    <div *ngIf="!isStatic" class="table-flex">
      <div class="flex flex-row">
        <div class="fc-tab-view">
          <div class="flex flex-direction-row mt-25">
            <ul class="nav nav-tabs fc-tabs" id="tabView" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="first-tab" data-bs-toggle="tab" data-bs-target="#first-tab-pane"
                  type="button" role="tab" aria-controls="first-tab-pane" (click)="resetForm('inProgress'); inProgressTab = true"
                  aria-selected="true">Inprogress</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="second-tab" data-bs-toggle="tab" data-bs-target="#second-tab-pane"
                  type="button" role="tab" aria-controls="second-tab-pane" (click)="resetForm('history'); inProgressTab = false"
                  aria-selected="false">History</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="tab-content" id="fcTabContent">
        <div class="tab-pane fade show active" id="first-tab-pane" role="tabpanel" aria-labelledby="Inprogress" tabindex="0" style="padding:5px">
          <app-data-table 
            [data]="approvalnotification" 
            [tableWidth]="'120%'" 
            [displayedColumns]="approvalActiveTable?.config?.displayedColumns" 
            [headerLabels]="approvalActiveTable?.config?.headerLabels"
            [actionButton]="true"  
            (selectedValues)="tableCheckedDataa($event)" 
            [withCheckBox]="false"  
            [fromWhere]="'approval'" 
            [searchBar]="true"  
            (approveData)="onApprove($event)" 
            (rejectData)="onreject($event)"
            [dateColumns]="approvalActiveTable?.config?.dateColumns"
            [timeColumns]="approvalActiveTable?.config?.timeColumns"
            [sideScreenColumn]="approvalActiveTable?.config?.sideScreenColumn">
          </app-data-table>
        </div>
        <div class="tab-pane fade" id="second-tab-pane" role="tabpanel" aria-labelledby="History" tabindex="1">
          <app-data-table  
            [data]="historyData"  
            [tableWidth]="'120%'"
            [displayedColumns]="historyActiveTable?.config?.displayedColumns" 
            [headerLabels]="historyActiveTable?.config?.headerLabels" 
            [fromWhere]="'leave'"  
            (selectedValues)="tableCheckedDataa($event)"
            [actionButton]="false" 
            [searchBar]="true" 
            [withCheckBox]="true"
            [dateColumns]="historyActiveTable?.config?.dateColumns"
            [timeColumns]="historyActiveTable?.config?.timeColumns"
            [sideScreenColumn]="historyActiveTable?.config?.sideScreenColumn">
          </app-data-table>
        </div>
      </div>
    </div>
    <div class="modal fade" id="approvalReject">
      <div class="modal-dialog d-flex align-items-center h-100">
        <div class="modal-content modal-custom">
          <div class="modal-header modal-custom-header modal-custom">
            <div class="modal-title fs-6">Rejection Reason</div>
            <app-fusion-button  [buttonType]= "'btn-close'" [dataDismiss]="'modal'"
            [fcBtnId]="'close'">
            </app-fusion-button>
          </div>
          <div class="modal-body modal-custom-body d-flex flex-column">
            <form [formGroup]="rejectionform">
              <textarea class="text-box" 
                formControlName="rejectReason"></textarea>
            </form>
            <div class="mt-5 d-flex justify-content-end">
              <app-fusion-button [buttonValue]="'Cancel'" [buttonType]="'text-only'" [dataDismiss]="'modal'"
                  [fcBtnId]="'myId'"></app-fusion-button>
              <app-fusion-button [buttonValue]="'Reject'" [dataDismiss]="'modal'"
                (buttonClickEmit)="reasonText()" [buttonDisable]="!rejectionform.valid" [fcBtnId]="'modalSave'">
              </app-fusion-button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
<!-- TO BE USED IN FUTURE ********************* DON'T REMOVE ********************* -->
<!-- <div class="main-content" *ngIf="approvalsTabToShow == 'settings'">
    Settings
</div> -->